export default __webpack_public_path__ + "src/assets/icn-status-badge-pending.8e45afe74694403fa3f5276709fa7a76.svg";